import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';

export default class SlideBoxes {
	constructor() {
		this.swiper = undefined;
	}

	init() {
		if ($('.slide-boxes__slideItem').length > 1) {
			this.swiper = new Swiper('.slide-boxes__slideActive', {
				loop: true,
				modules: [Navigation, Pagination, Autoplay],
				slidesPerView: 1,
				spaceBetween: 0,
				autoplay: {
					delay: 4000,
					disableOnInteraction: false
				},
				navigation: {
					nextEl: '.slide-boxes__slideArrowNext',
					prevEl: '.slide-boxes__slideArrowPrev'
				},
				pagination: {
					el: '.slide-boxes__pagination',
					clickable: true,
					type: 'bullets'
				},
				breakpoints: {
					0: {
						slidesPerView: 1.25,
						spaceBetween: 20
					},
					768: {
						slidesPerView: 2,
						spaceBetween: 30
					},
					1000: {
						slidesPerView: 3,
						spaceBetween: 35
					}
				}
			});
		}
	}

	destroy() {
		if (this.swiper !== undefined) {
			this.swiper.destroy();
		}
	}
}
